// De bevestigingsmail van een huisbezoek aan het huishouden. Puur, zodat de
// twee dingen die in het component misgingen te toetsen zijn: zonder bruikbaar
// e-mailadres ging er een mail uit met `to: ""`, en zonder naam begon hij met
// "Beste ,". Nodig omdat `Tasks.jsx` de inhoud inline bouwde.
// AI-CONTEXT: See docs/features/huishouden-vaste-gegevens.md (T7, bug 2)

import { looksLikeEmail } from './householdEmail'
import normalizeEmail from '../normalizeEmail'

/**
 * @typedef {object} ConfirmationMailInput
 * @property {string} [adressName] - Naam van het huishouden (vast veld `Naam`)
 * @property {string} [adressEmail] - E-mailadres van het huishouden (vast veld `Email`)
 * @property {string} companyName - Naam van de organisatie
 * @property {string} whenText - Wanneer, als zin ('maandag 3 november van …')
 * @property {string} replyTo - Waar antwoorden heen gaan
 */

/**
 * @param {ConfirmationMailInput} input
 * @returns {{to: string, message: object}|null} Het `to` en `message` van het Email-document, of null als er niemand is om het naartoe te sturen
 */
const buildConfirmationMail = ({ adressName, adressEmail, companyName, whenText, replyTo }) => {
    const to = normalizeEmail(adressEmail)
    if (!looksLikeEmail(to)) return null

    const naam = String(adressName || '').trim() || 'bewoner'

    return {
        to,
        message: {
            subject: `Huisbezoek gepland op ${whenText}`,
            html: `Beste ${naam},<br><br>
          Er is een huisbezoek gepland door ${companyName} op <b>${whenText}</b> om uw woning te verduurzamen.<br><br>
          Mocht u niet aanwezig zijn of anderszins verhinderd zijn, neem dan contact met ons op via ${replyTo}.<br><br>
          Vriendelijke groet,<br><br>
          Team ${companyName}<br><br>
        `,
            Gebruikersnaam: naam,
            Emailadres: to,
            Type: 'Housevisit confirmation mail',
        },
    }
}

export default buildConfirmationMail
